/**
 * exportCsv — RFC-4180-ish CSV serialization + browser download for Analytics
 * report tables. `toCsv` is pure (unit-tested); `downloadCsv` touches the DOM.
 */

/** columns: [{ key, label }]; rows: array of objects → CSV string. */
export function toCsv(columns = [], rows = []) {
  const esc = (v) => {
    const s = v == null ? '' : String(v);
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = columns.map((c) => esc(c.label)).join(',');
  const body = rows.map((r) => columns.map((c) => esc(r[c.key])).join(',')).join('\n');
  return body ? `${header}\n${body}` : header;
}

/** Trigger a client-side CSV download (no server round-trip). */
export function downloadCsv(filename, columns, rows) {
  try {
    const csv = toCsv(columns, rows);
    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = /\.csv$/i.test(filename) ? filename : `${filename}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 0);
  } catch (_) { /* download blocked (sandbox) — no-op */ }
}
